module.exports = __webpack_public_path__ + "img/20200514_145255.123c3dee.jpg";